var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.damageTypeItems,
      "label": _vm.$t('components.partner.PartnerReportCreateForm.damageTypeLabel'),
      "outlined": "",
      "clearable": ""
    },
    model: {
      value: _vm.value.damageType,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "damageType", $$v);
      },
      expression: "value.damageType"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": Object.values(_vm.CoverageTypeEnum),
      "label": _vm.$t('components.partner.PartnerReportCreateForm.coverageTypeLabel'),
      "outlined": "",
      "clearable": ""
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [_vm._v(" " + _vm._s(_vm.$t("enums.CoverageTypeEnum.".concat(item))) + " ")];
      }
    }, {
      key: "item",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return [_vm._v(" " + _vm._s(_vm.$t("enums.CoverageTypeEnum.".concat(item))) + " ")];
      }
    }]),
    model: {
      value: _vm.value.coverageType,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "coverageType", $$v);
      },
      expression: "value.coverageType"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('custom-field-boolean', {
    attrs: {
      "customField": {
        label: _vm.$t('objects.report.isDrivable')
      }
    },
    model: {
      value: _vm.value.isDrivable,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "isDrivable", $$v);
      },
      expression: "value.isDrivable"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('custom-field-boolean', {
    attrs: {
      "customField": {
        label: _vm.$t('objects.report.isRoadworthy')
      }
    },
    model: {
      value: _vm.value.isRoadworthy,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "isRoadworthy", $$v);
      },
      expression: "value.isRoadworthy"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('custom-field-boolean', {
    attrs: {
      "customField": {
        label: _vm.$t('objects.report.isWrapped')
      }
    },
    model: {
      value: _vm.value.isWrapped,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "isWrapped", $$v);
      },
      expression: "value.isWrapped"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('custom-field-boolean', {
    attrs: {
      "customField": {
        label: _vm.$t('objects.report.isWrapDamaged')
      }
    },
    model: {
      value: _vm.value.isWrapDamaged,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "isWrapDamaged", $$v);
      },
      expression: "value.isWrapDamaged"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": Object.values(_vm.TotalLossType),
      "label": _vm.$t('objects.report.totalLoss'),
      "auto-select-first": "",
      "outlined": "",
      "clearable": ""
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function fn(_ref3) {
        var item = _ref3.item;
        return [_vm._v(" " + _vm._s(_vm.$t("enums.TotalLossType.".concat(item))) + " ")];
      }
    }, {
      key: "item",
      fn: function fn(_ref4) {
        var item = _ref4.item;
        return [_vm._v(" " + _vm._s(_vm.$t("enums.TotalLossType.".concat(item))) + " ")];
      }
    }]),
    model: {
      value: _vm.value.totalLoss,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "totalLoss", $$v);
      },
      expression: "value.totalLoss"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "outlined": "",
      "label": _vm.$t('objects.report.title')
    },
    model: {
      value: _vm.value.title,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "title", $$v);
      },
      expression: "value.title"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-textarea', {
    attrs: {
      "outlined": "",
      "label": _vm.$t('objects.report.message')
    },
    model: {
      value: _vm.value.message,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "message", $$v);
      },
      expression: "value.message"
    }
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }